import axios from "axios";
import * as AppSettingsService from "./AppSettingsService";
import { debounceAndTokenizeApiCall } from "../helpers/Optimizers";
import { LocationAddressType } from "../types/ApplicationTypes";
import {
  AutoCompleteAddresses,
  PlaceDetails,
  UspsAddress,
} from "../types/LocationTypes";
import { IWandaServiceArea } from "../types/TripTypes";

const appSettings = AppSettingsService;

export async function getAutoCompleteAddress(
  searchText: string
): Promise<AutoCompleteAddresses> {
  const apiUrl = `${appSettings.getAppApiUrl()}/common/map/v1/autoComplete`;
  const params = { input: searchText };

  try {
    const data = await debounceAndTokenizeApiCall<AutoCompleteAddresses>(
      apiUrl,
      800,
      params
    );
    return data;
  } catch (error) {
    throw error;
  }
}

export async function getWandaServiceArea(
  zipCode?: string,
  recaptchaToken?: string
): Promise<IWandaServiceArea[]> {
  try {
    const response = await axios.get(
      `${appSettings.getAppApiUrl()}/ccp/Registration/v1/GetWandaServiceArea?zipcode=${zipCode}&recaptchaToken=${recaptchaToken}`
    );
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function getPlaceDetails(
  placeId: string,
  description?: string,
): Promise<PlaceDetails> {
  try {
    const response = await axios.get(
      `${appSettings.getAppApiUrl()}/common/map/v1/placesDetails`,
      {
        params: {
          Place_Id: placeId,
          description,
        },
      },
    );
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function validateUspsAddress(location: LocationAddressType) {
  try {
    const response = await axios.post(
      `${appSettings.getAppApiUrl()}/common/map/v1/uspsAddress`,
      location
    );
    return response.data;
  } catch (error) {
    throw error;
  }
}
